document.addEventListener('DOMContentLoaded', () => {
  const gallery = document.querySelector('.product__media-list, .product__media');
  const dots = document.querySelectorAll('.product-media-dot');

  if (!gallery || dots.length === 0) return;

  const mediaItems = gallery.querySelectorAll('[data-media-id], img');

  let activeIndex = 0;

  const setActiveDot = (index) => {
    dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === index);
    });
  };

  gallery.addEventListener('scroll', () => {
    const scrollLeft = gallery.scrollLeft;
    const width = gallery.offsetWidth;
    const index = Math.round(scrollLeft / width);

    if (index !== activeIndex && dots[index]) {
      activeIndex = index;
      setActiveDot(index);
    }
  });
});